import * as React from 'react';
import { Button } from '@/components/ui/button';
import { isAdminNavEntryActive } from '@/components/admin-nav-item';
import type { PermissionCatalogEntry } from '@/lib/types';
import { cn } from '@/lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

/** Hover timing for header nav groups (Operations, Admin, Tools). */
const NAV_GROUP_HOVER_OPEN_MS = 0;
const NAV_GROUP_HOVER_CLOSE_MS = 120;

type AdminNavDropdownGroupProps = {
  label: string;
  children: React.ReactNode;
  entries?: PermissionCatalogEntry[];
  activeRoute?: string;
};

/**
 * Admin header nav group — opens its page list on hover (click still works as fallback).
 * Shared by `AppShell` and `RoleNavPreview`.
 */
export function AdminNavDropdownGroup({ label, children, entries = [], activeRoute = '' }: AdminNavDropdownGroupProps) {
  const isActive = entries.some((entry) => isAdminNavEntryActive(entry, activeRoute));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        openOnHover
        delay={NAV_GROUP_HOVER_OPEN_MS}
        closeDelay={NAV_GROUP_HOVER_CLOSE_MS}
        render={
          <Button
            variant="ghost"
            size="sm"
            className={cn(isActive && 'brand-nav-active font-semibold hover:bg-[var(--brand-primary-soft)]')}
          />
        }
      >
        {label}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="max-h-none overflow-visible">
        <DropdownMenuGroup>
          <DropdownMenuLabel>{label}</DropdownMenuLabel>
          {children}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
